import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { ComplaintsDataCollectionPage } from './ComplaintsPage/ComplaintsDataCollectionPage'

function ComplaintsPage() {
  return (
    <ResponsivePage.Body>
      <ComplaintsDataCollectionPage />
    </ResponsivePage.Body>
  )
}

export default ComplaintsPage
